module.exports = __webpack_public_path__ + "7c9eaa9a20866cd3225efd4e01dacfe7.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-regular.woff
 ** module id = 8
 ** module chunks = 0
 **/